"use client";

import { useCheckout, usePassportProvider } from "@/context";
import * as checkout from "@imtbl/checkout-sdk";
import { useEffect, useState } from "react";

export const CommerceWidget = ({
  params,
  config,
  onClose,
  onSuccess,
  onFailure,
}: {
  params: checkout.CommerceWidgetParams;
  config?: checkout.CommerceWidgetConfiguration;
  onClose: () => void;
  onSuccess: (event: checkout.CommerceSuccessEvent) => void;
  onFailure: (event: checkout.CommerceFailureEvent) => void;
}) => {
  const [commerceWidget, setCommerceWidget] =
    useState<checkout.Widget<typeof checkout.WidgetType.IMMUTABLE_COMMERCE>>();

  const { passportClient } = usePassportProvider();
  const { checkoutClient: checkoutSDK } = useCheckout();

  useEffect(() => {
    (async () => {
      const widgetsFactory = await checkoutSDK.widgets({
        config: {
          theme: checkout.WidgetTheme.DARK,
        },
      });

      const commerceWidget = widgetsFactory.create(
        checkout.WidgetType.IMMUTABLE_COMMERCE,
        {
          provider: new checkout.WrappedBrowserProvider(
            await passportClient.connectEvm(),
          ),
          config: {
            theme: checkout.WidgetTheme.DARK,
            ...config,
          },
        },
      );
      setCommerceWidget(commerceWidget);
    })();
  }, [passportClient, checkoutSDK, config]);

  useEffect(() => {
    if (!commerceWidget) return;
    commerceWidget.mount("mount-commerce-widget-balance-page", params);
    commerceWidget.addListener(checkout.CommerceEventType.CLOSE, onClose);
    commerceWidget.addListener(checkout.CommerceEventType.SUCCESS, onSuccess);
    commerceWidget.addListener(checkout.CommerceEventType.FAILURE, onFailure);
    return () => {
      commerceWidget.removeListener(checkout.CommerceEventType.SUCCESS);
      commerceWidget.removeListener(checkout.CommerceEventType.CLOSE);
      commerceWidget.removeListener(checkout.CommerceEventType.FAILURE);
      commerceWidget.unmount();
    };
  }, [params, onClose, onSuccess, onFailure, commerceWidget]);

  return <div id="mount-commerce-widget-balance-page" />;
};
